import React from 'react';
import { PATH_LOCATEADEALER } from '../constants';

class MaintenanceMessage extends React.Component {
    render() {
        return (
            <div className="my-3 p-4 aui-color-red aui-color-text-light">
                <p className="mb-3"><b>We are currently undergoing website maintenance</b> and while you can still complete and submit this form, please be aware that there will be a delay in our response until the week commencing 30 August.</p>
                {this.props.opts.length > 0 && <p>If you would like a quicker response please:</p>}
                <ul>
                {this.props.opts.map((opt, i) => {
                    return (
                        <li key={`opt${i}`}>{opt}</li>
                    );
                })}
                </ul>
            </div>
        );
    }
}

MaintenanceMessage.defaultProps = {
    opts: [
        <>Use our <a className="aui-textlink" href={`https://forms.audi.com.au${PATH_LOCATEADEALER}`} target="_blank">dealer locator</a> to contact your local dealer directly</>,
        <>Email us at <a className="aui-textlink" href="mailto:customerassistance@audi-info.com.au">customerassistance@audi-info.com.au</a></>,
        <>Call us on <a className="aui-textlink" href="tel:1300557405">1300 557 405</a></>
    ]
};

export default MaintenanceMessage;
